// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
      // suggestionMobileStyle: "style3"
	}
};

(function() {
	BoostPFS.inject(this);
	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

    var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '#toggleSearch';
    var searchInputMobile = '.ui-autocomplete-input';
    var searchCloseButtonMobile = '.menu-mobile_nav #close';
   
      jQ(searchCloseButtonMobile).click(function(e) {
      console.log("click")
      //e.preventDefault();
      //e.stopPropagation();
      // jQ(searchInputMobile).focus();
      // self.openSuggestionMobile();
      // jQ(searchCloseButtonMobile).trigger('click');
      jQ(".boost-pfs-search-btn-clear-suggestion").click()

    });

    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });

    $(searchButtonMobile).click(function(){
      const wid =jQ(window).width();
      if(wid <=991){
        setTimeout(()=>{
          jQ(".boost-pfs-search-suggestion-mobile-top-panel")[0].style.setProperty('display', 'block', 'important');
        },1)
      }
    })
    
  }
  const serachInputVal = $("#search-form input").val() || '';
  if(serachInputVal){
     $("#search-form .clear-val").css({display:'block'})
  }
  $("#search-form input").on('input',function(e){
    const charLenght = e.target.value.length || 0;
    if(charLenght > 0){
      $("#search-form .clear-val").css({display:'block'})
    }else{
      $("#search-form .clear-val").css({display:'none'})
    }
  });
  
  $(".clear-val").click(function(){
    $(this).css({display:'none'})
    $('.boost-pfs-search-suggestion-wrapper').css({display:'none'})
     $("#search-form input").val('');
  })
  
})();